import { useContext } from "react";
import { CustomerContext } from "../context/CustomerContext";
export const useCustomerContext = () => useContext(CustomerContext);
